<template>
  <Teleport to="body">
    <div class="fixed bottom-4 right-4 z-[10001] flex flex-col gap-2">
      <TransitionGroup name="fade">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="rounded-standard bg-secondary border border-tertiary px-4 py-3 shadow-lg text-sm"
          :class="toast.type === 'success' ? 'text-accent' : toast.type === 'error' ? 'text-red-500' : 'text-text-main'"
        >
          {{ toast.message }}
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts } = useToast()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
